/**
 * Last Updated Component
 * 
 * Shows last updated date for legal/policy pages.
 * Used consistently across Terms, Privacy, and other dated content.
 */

interface LastUpdatedProps {
  date: string;
  className?: string;
}

export default function LastUpdated({ date, className = '' }: LastUpdatedProps) {
  return (
    <p className={`text-sm text-text-muted italic ${className}`}>
      Last Updated: {date}
    </p>
  );
}